import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import createMiddleware from './client';
import reducer from './reducer';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  reducer,
  undefined,
  composeEnhancers(applyMiddleware(createMiddleware(), thunk))
);

export { store };
